import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyLoginCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.69002 12.0933L7.75922 14.0281C7.59239 14.1963 7.49858 14.4235 7.49811 14.6604V15.6078C7.49811 16.1018 7.89853 16.5022 8.39248 16.5022H9.34388C9.58132 16.5025 9.80902 16.4077 9.97614 16.2391L11.9029 14.3083C12.2558 14.4318 12.6265 14.497 13.0004 14.5013C14.5531 14.5269 15.9433 13.5432 16.4357 12.0704C16.9282 10.5976 16.4092 8.97554 15.1534 8.06204C13.8976 7.14854 12.1946 7.15434 10.945 8.07637C9.69542 8.9984 9.18757 10.6239 9.69002 12.0933Z",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0004 10.9582C12.9778 10.9582 12.9594 10.9766 12.9594 10.9992C12.9594 11.0219 12.9778 11.0402 13.0004 11.0402C13.0231 11.0402 13.0414 11.0219 13.0414 10.9992C13.0414 10.9766 13.0231 10.9582 13.0004 10.9582",
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 11.9998,
			r: 9.00375,
			stroke: "#323232",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgKeyLoginCircle;
